







































import DictMixin from '@/mixins/dict-mixin';
import { DimensionItemDto } from '@/services/dimension';
import { mixins } from 'vue-class-component';
import { Vue, Component, PropSync } from 'vue-property-decorator';

@Component
export default class DimensionForm2 extends mixins(DictMixin) {
  @PropSync('dimFieldList') syncDimFieldList!: DimensionItemDto[];

  addList() {
    this.syncDimFieldList.push({
      status: 0,
      fieldSort: 1
    });
  }

  removeList(index: number) {
    this.syncDimFieldList.splice(index, 1);
  }
}
